import React, { useRef } from 'react'
import * as d3 from 'd3'
import useSize from 'hooks/useSize'
import './styles.scss'

interface RankingProps {
  position: number
  data: []
  labels: boolean
  inverted: boolean
  isSmall: boolean
}

const isMobile = window.innerWidth < 900

export const Ranking = ({
  data,
  position,
  labels,
  inverted,
  isSmall
}: RankingProps) => {
  const ranks = {}
  const svgRef = useRef<SVGSVGElement>(null)
  const [container, size] = useSize()
  const width = size.width
  const height = width * (isMobile ? 0.3 : isSmall ? 0.2 : 0.3)
  const padding = 6
  const gutterTop = padding
  const gutterRight = padding
  const gutterLeft = padding
  const gutterBottom = padding
  const plotArea = {
    top: gutterTop,
    right: width - gutterRight,
    left: gutterLeft,
    bottom: height - gutterBottom
  }

  const ticks = [0, 15, 30]

  data.forEach(d => {
    ranks[d.rank]
      ? (ranks[d.rank].count += 1)
      : (ranks[d.rank] = {
          count: ranks[d.rank] = 1,
          fortune: d.fortune,
          formatedFortune: d.formatedFortune
        })
  })
  const ranksData = Object.keys(ranks).map((r, i) => ({
    binPosition: i,
    binCount: parseInt(ranks[r].count),
    binRank: parseInt(r),
    binFortune: ranks[r].fortune,
    binFormatedFortune: ranks[r].formatedFortune
  }))

  const barWidth = size.width / ranksData.length - 1
  console.log(ranksData)

  const xAxisScale = React.useMemo(
    () =>
      d3
        .scaleLinear()
        .domain([
          d3.min(ranksData, d => d.binPosition),
          d3.max(ranksData, d => d.binPosition)
        ])
        .range([plotArea.left, plotArea.right]),
    [size]
  )

  const yAxisScale = React.useMemo(
    () =>
      d3
        .scaleLinear()
        .domain([0, d3.max(ranksData, d => d.binCount)])
        .range([plotArea.bottom, plotArea.top]),
    [size]
  )

  const selectedBinPosition = ranksData.find(r => r.binRank === position)
    ?.binPosition

  return (
    <div
      ref={container}
      className={`ranking-chart ${inverted ? 'inverted' : ''}`}
    >
      <div style={{ position: 'relative', zIndex: 0 }}>
        {ticks.map((t, i) => (
          <div key={`tick-${i}`}>
            <div
              style={{
                transform: `translateY(${yAxisScale(t)}px)`,
                height: 0,
                top: 0,
                width: width,
                left: 0,
                bottom: gutterBottom
              }}
              className='tick'
            />
            <div
              key={`label-${i}`}
              style={{
                transform: `translateY(${yAxisScale(t)}px)`,
                height: plotArea.bottom - plotArea.top - 35,
                top: 0,
                left: 0
              }}
              className='label'
            >
              {i > 0 && t} {i === 2 && 'riches'}
            </div>
          </div>
        ))}
      </div>

      <svg ref={svgRef} width={width} height={height}>
        {ranksData.map(r => {
          const barHeight = plotArea.bottom - yAxisScale(r.binCount)

          return (
            <g key={`bin-${r.binPosition}`}>
              {/* d={`M${r.binPosition * (barWidth + 1)},${plotArea.bottom - barHeight} h${barWidth} a5,5 0 0 1 5,5 v${barHeight} h${-barWidth} v${-barHeight} a5,5 0 0 1 5,-5`} */}
              <path
                className={
                  selectedBinPosition === r.binPosition ? 'active' : ''
                }
                d={`M${r.binPosition * (barWidth + 1)},${plotArea.bottom -
                  barHeight} h${barWidth} v${barHeight} h${-barWidth} v${-barHeight} z`}
              />
              {/* <rect
                className={
                  selectedBinPosition === r.binPosition ? 'active' : ''
                }
                width={barWidth}
                height={barHeight}
                x={r.binPosition * (barWidth + 1)}
                y={plotArea.bottom - barHeight}
              /> */}
            </g>
          )
        })}
      </svg>

      {ranksData[selectedBinPosition].binCount < 10 && (
        <div
          className={`selected-profile-rank-label ${
            ranksData[selectedBinPosition].binPosition * (barWidth + 1) <
            size.width / 2
              ? 'left'
              : 'right'
          }`}
          style={{
            transform: `translate(${ranksData[selectedBinPosition].binPosition *
              (barWidth + 1) +
              barWidth / 2}px, ${yAxisScale(
              ranksData[selectedBinPosition].binCount
            ) - 60}px)`
          }}
        >
          {/* <div>Sa position</div> */}
          {/* <svg
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            x='0px'
            y='0px'
            viewBox='0 0 20.5 17.6'
            xmlSpace='preserve'
          >
            <path
              d='M2.1,1.1c2.2,0,7.6,0.3,11.4,3.8c2.6,2.4,3.9,5.9,3.9,10.2l1.4-1.5l0.4,0.3l-2,2.2L15,14l0.4-0.4l1.5,1.5
	c0-4.3-1.2-7.6-3.7-10c-3.6-3.4-8.9-4-11-4'
            />
          </svg> */}
        </div>
      )}
      <div className='ranking-legend'>
        <div className='ui two columns grid'>
          <div className='column'>← {ranksData[0].binFormatedFortune}</div>
          <div className='column right aligned'>
            {ranksData[ranksData.length - 1].binFormatedFortune} →
          </div>
        </div>
      </div>
    </div>
  )
}
